'use client';
import React, { useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import GoogleAnalytics from '../views/GoogleAnalytics';
import { GenerateGlobalVariables } from '../app/GenerateGlobalVariables';
import AppErrorPage from '../views/components/AppErrorPage';
import AppLoadingPage from '../views/components/AppLoadingPage';
import DryDebugger from '../views/DryDebugger';
import Drynotes from '../views/Drynotes';
import BreakPoints from '../views/BreakPoints';
import UrlSync from '../components/UrlSync';
import NotesSync from '../components/NotesSync';
import InteractionTracker from '../components/InteractionTracker';
import logger from '../logger';
import '../styles/styles.scss';

/**
 * Main React application entry-point for both the server and client.
 * 
 * NOTE: GlobalStateProvider is now in Routes.js to prevent remounting
 * when routes change. This ensures the state machine persists across
 * route changes and note selections.
 */
/**
 * Memoized to prevent unnecessary re-renders when URL changes.
 * React Router will update the URL via client-side routing (replaceState),
 * which doesn't cause page reloads or state resets.
 */
const Main = React.memo((props) => {
  useEffect(() => {
    // You can open the inspector by pressing Ctrl+Shift+I
    // You can also change the keybinding by providing a different key
    // to the inspect function, e.g. inspect({ key: 'i' });
  }, []);

  return (
    <>
      <GenerateGlobalVariables />
      <GoogleAnalytics />
      <ErrorBoundary fallback={<div>Drynotes failed to load</div>}>
        <BreakPoints />
        <AppErrorPage />
        <AppLoadingPage />
        <UrlSync />
        <NotesSync />
        <InteractionTracker />
        <Drynotes />
        <DryDebugger />
      </ErrorBoundary>
    </>
  );
  /*
      @todo Look into using https://www.npmjs.com/package/react-responsive
      <ReactBreakpoints
        breakpoints={BREAKPOINTS}
        guessedBreakpoint={guessedBreakpoint}
        defaultBreakpoint={guessedBreakpoint}
      >
        <Drynotes />
      </ReactBreakpoints>*/
});

Main.displayName = 'Main';

export default Main;
